/**
 * A small, fixed list of accessibility-flavoured starter prompts shown as chips
 * on the venue assistant's empty state. Each entry references an i18n key so the
 * UI layer resolves the display text (and the raw English fallback) itself.
 */
export type StarterQuestion = {
  id: string;
  i18nKey: string;
};

export const VENUE_ASSISTANT_STARTER_QUESTIONS: StarterQuestion[] = [
  { id: "wheelchair", i18nKey: "askAiStarterWheelchair" },
  { id: "openingHours", i18nKey: "askAiStarterOpeningHours" },
  { id: "stepsEntrance", i18nKey: "askAiStarterSteps" },
  { id: "accessibleBathroom", i18nKey: "askAiStarterBathroom" },
  { id: "openNow", i18nKey: "askAiStarterOpenNow" },
];
